const coinPaymentModalStyles = {
    container: `absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-white max-w-[400px] text-black min-w-[300px] overflow-hidden`,
    banner: `relative rounded-b-[50%] h-[100px] bg-primaryHeading`,
    imageContainer: `absolute -bottom-4 left-1/2 -translate-x-1/2`,
    image: `flex items-center justify-center max-w-[100px] h-auto`,
    closeButton: `absolute top-2 right-2 text-white`,
    innerContainer: `flex flex-col gap-[11px] justify-center items-center text-center p-[25px]`,
    heading: `text-[27px] font-Suisse text-paymentSuccess text-center`,
    errorHeading: `text-[27px] font-Suisse text-paymentError text-center`,
    doneIcon: `flex justify-center items-center rounded-full w-[80px] h-[80px]`,
    successImage: `max-w-[70px] h-auto`,
    message: `text-[14px] text-themeColor text-center`,
    button: `!w-fit px-10 !rounded-full`,
 }
 
 export  { coinPaymentModalStyles }